import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const { init, fetching } = createAllActions(types.SCOPE);

export const addOrRule = index => ({
  type: types.ADD_OR_RULE,
  index,
});

export const updateOrRule = (index, payload) => ({
  type: types.UPDATE_OR_RULE,
  index,
  payload,
});

export const deleteOrRule = index => ({
  type: types.DELETE_OR_RULE,
  index,
});

export const createConfig = payload => ({
  type: types.CREATE_CONFIG,
  payload,
});

export const updateConfig = (payload, changeType) => ({
  type: types.UPDATE_CONFIG,
  payload,
  changeType,
});

export const updateConfigConditions = payload => ({
  type: types.UPDATE_CONFIG_CONDITIONS,
  payload,
});

export const changeConfigContainerVisibility = visible => ({
  type: types.CHANGE_CONFIG_CONTAINER_VISIBILITY,
  visible,
});

export const clearConfigForm = () => ({
  type: types.CLEAR_CONFIG_FORM,
});

export {
  init, fetching,
};
